var React = require('react');

function Padlock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.87 6.95c.26.26.38.57.38.93v4.81A1.3 1.3 0 0 1 10.94 14H1.31A1.3 1.3 0 0 1 0 12.69V7.88c0-.37.13-.68.38-.93.26-.26.56-.38.93-.38h.88V3.94A3.98 3.98 0 0 1 6.12 0c.71 0 1.37.18 1.97.53a4 4 0 0 1 1.97 3.43v.63a.6.6 0 0 1-.19.46.6.6 0 0 1-.46.2.6.6 0 0 1-.46-.19.6.6 0 0 1-.2-.47v-.65a2.5 2.5 0 0 0-.78-1.86 2.58 2.58 0 0 0-1.87-.77 2.61 2.61 0 0 0-2.6 2.65v2.6h7.44c.36 0 .67.13.93.39zm-.93.93H1.31v4.81h9.62V7.88zm-4.27 3.71a.74.74 0 0 0 .22-.55V9.52c0-.22-.07-.4-.22-.55-.14-.15-.33-.22-.55-.22s-.4.07-.55.22a.75.75 0 0 0-.21.55v1.53c0 .22.07.4.22.55.15.15.33.22.55.22s.4-.08.54-.23z"}));
}

Padlock.defaultProps = {"viewBox":"0 0 12.25 14"};

module.exports = Padlock;

Padlock.default = Padlock;
